import { createI18n } from 'vue-i18n';

const DEFAULT_LOCALE = 'it';

export const localeLanguage = (locale) => String(locale || DEFAULT_LOCALE)
    .trim()
    .replaceAll('_', '-')
    .split('-')[0]
    .toLowerCase();

export const normalizeLocalization = (localization = {}, messages = {}) => {
    const availableLocales = Object.keys(messages);
    const requestedFallback = localeLanguage(localization.default_locale);
    const fallbackLocale = availableLocales.includes(requestedFallback)
        ? requestedFallback
        : availableLocales.includes(DEFAULT_LOCALE) ? DEFAULT_LOCALE : availableLocales[0] ?? DEFAULT_LOCALE;
    const requestedLocale = localeLanguage(localization.locale);
    const locale = availableLocales.includes(requestedLocale) ? requestedLocale : fallbackLocale;

    return {
        ...localization,
        locale,
        default_locale: fallbackLocale,
        interface_locales: Array.isArray(localization.interface_locales)
            ? localization.interface_locales.map(localeLanguage)
            : [fallbackLocale],
    };
};

export const createFrontendI18n = (localization = {}, messages = {}) => {
    const normalized = normalizeLocalization(localization, messages);

    return createI18n({
        legacy: false,
        globalInjection: false,
        locale: normalized.locale,
        fallbackLocale: normalized.default_locale,
        messages,
        escapeParameter: true,
        warnHtmlMessage: true,
        missingWarn: import.meta.env.DEV,
        fallbackWarn: false,
    });
};

export const syncFrontendLocale = (i18n, localization = {}) => {
    const normalized = normalizeLocalization(localization, i18n.global.messages.value);
    i18n.global.locale.value = normalized.locale;
    i18n.global.fallbackLocale.value = normalized.default_locale;

    if (typeof document !== 'undefined') {
        document.documentElement.lang = normalized.locale;
    }

    return normalized.locale;
};
